export const PHONE = "PHONE";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const NEXT_STEP = "NEXT_STEP";
export const LAST_STEP = "LAST_STEP";
export const GET_PRICE = "GET_PRICE";
export const ASYNC_START = "ASYNC_START";
export const ASYNC_END = "ASYNC_END";
export const SELECT_SERVICE = "SELECT_SERVICE";
export const ADD_EXPENSIVE_ITEM = "ADD_EXPENSIVE_ITEM";
export const REMOVE_EXPENSIVE_ITEM = "REMOVE_EXPENSIVE_ITEM";
export const ADD_WORKER = "ADD_WORKER";
export const REMOVE_WORKER = "REMOVE_WORKER";
export const ADD_TECHNICAL_WORKER = "ADD_TECHNICAL_WORKER";
export const REMOVE_TECHNICAL_WORKER = "REMOVE_TECHNICAL_WORKER";
export const ADD_SET_WORKER = "ADD_SET_WORKER";
export const REMOVE_SET_WORKER = "REMOVE_SET_WORKER";
export const ADD_PACKING_WORKER = "ADD_PACKING_WORKER";
export const REMOVE_PACKING_WORKER = "REMOVE_PACKING_WORKER";
export const SET_TIME = "SET_TIME";
export const PLUS_HOUR = "PLUS_HOUR";
export const MINUS_HOUR = "MINUS_HOUR";
export const PLUS_MINUTE = "PLUS_MINUTE";
export const MINUS_MINUTE = "MINUS_MINUTE";
export const SET_DATE = "SET_DATE";
export const SET_TIMESTAMP = "SET_TIMESTAMP";
export const ORIGIN_LOCATION_SELECTED = "ORIGIN_LOCATION_SELECTED";
export const DESTINATION_LOCATION_SELECTED = "DESTINATION_LOCATION_SELECTED";
export const RESET_DESTINATION = "DESTINATION_MARKER_TOGGLE_DISPLAY";
export const CHANGE_ORIGIN_ADDRESS = "CHANGE_ORIGIN_ADDRESS";
export const CHANGE_DESTINATION_ADDRESS = "CHANGE_DESTINATION_ADDRESS";
export const PLUS_ORIGIN_FLOOR = "PLUS_ORIGIN_FLOOR";
export const MINUS_ORIGIN_FLOOR = "MINUS_ORIGIN_FLOOR";
export const PLUS_DESTINATION_FLOOR = "PLUS_DESTINATION_FLOOR";
export const MINUS_DESTINATION_FLOOR = "MINUS_DESTINATION_FLOOR";
export const UPDATE_ORIGIN_LATLNG = "UPDATE_ORIGIN_LATLNG";
export const UPDATE_DESTINATION_LATLNG = "UPDATE_DESTINATION_LATLNG";
export const SHOW_ERROR_ALERT = "SHOW_ERROR_ALERT";
export const HIDE_ERROR_ALERT = "HIDE_ERROR_ALERT";
export const SHOW_SUCCESS_ALERT = "SHOW_SUCCESS_ALERT";
export const HIDE_SUCCESS_ALERT = "HIDE_SUCCESS_ALERT";
export const SHOW_WARNING_ALERT = "SHOW_WARNING_ALERT";
export const HIDE_WARNING_ALERT = "HIDE_WARNING_ALERT";
export const CHANGE_COUPON = "CHANGE_COUPON";
export const WRONG_COUPON = "DELETE_COUPON";
export const CHECK_COUPON = "CHECK_COUPON";
export const SHOW_ORDER_ALERT = "SHOW_ORDER_ALERT";
export const HIDE_ORDER_ALERT = "HIDE_ORDER_ALERT";
export const SHOW_PHONE_ALERT = "SHOW_PHONE_ALERT";
export const HIDE_PHONE_ALERT = "HIDE_PHONE_ALERT";
export const SHOW_AUTH_ALERT = "SHOW_AUTH_ALERT";
export const HIDE_AUTH_ALERT = "HIDE_AUTH_ALERT";
export const CHANGE_RECEIVER_NAME = "CHANGE_RECEIVER_NAME";
export const CHANGE_RECEIVER_LAST_NAME = "CHANGE_RECEIVER_LAST_NAME";
export const CHANGE_RECEIVER_PHONE = "CHANGE_RECEIVER_PHONE";
export const HIDE_LOGIN_ALERT = "HIDE_LOGIN_ALERT";
export const CHANGE_AUTH_PHONE = "CHANGE_AUTH_PHONE";
export const CHANGE_AUTH_CODE = "CHANGE_AUTH_CODE";
export const VERIFICATION_CODE_SENT = "VERIFICATION_CODE_SENT";
export const SUBMIT_AUTH_CODE = "SUBMIT_AUTH_CODE";
export const USER_IS_AUTHENTICATED = "USER_IS_AUTHENTICATED";
export const SEND_ORDER = "SEND_ORDER";
export const GET_ORDER = "GET_ORDER";
export const GET_BILL = "GET_BILL";
export const REMOVE_INVOICE = "REMOVE_INVOICE";
export const SET_USER_ID = "SET_USER_ID";
export const STRINGIFY_SHIT = "STRINGIFY_SHIT";
export const SHOULD_LOGIN = "SHOULD_LOGIN";
export const RESET_STATE = "RESET_STATE";
export const CHANGE_PROFILE_INPUT = "CHANGE_PROFILE_INPUT";
export const GET_PROFILE = "GET_PROFILE";
export const STORE_PROFILE = "STORE_PROFILE";
export const AUTH_CODE_ERROR = "AUTH_CODE_ERROR";
export const COPY_RECEIVER_NAME = "COPY_RECEIVER_NAME";
export const CHANGE_ORIGIN_BUILDING_NUM = "CHANGE_ORIGIN_BUILDING_NUM";
export const CHANGE_DEST_BUILDING_NUM = "CHANGE_DEST_BUILDING_NUM";
export const HANDLE_BUILDING_NUMS = "HANDLE_BUILDING_NUMS";
export const INVOICE_PAYED = "INVOICE_PAYED";
export const PREPARE_ORDER = "PREPARE_ORDER";
export const SUBMIT_ORDER = "SUBMIT_ORDER";
export const SET_DISCOUNT_CHANGES = "SET_DISCOUNT_CHANGES";
export const ORDER_CANCELED = "ORDER_CANCELED";
export const RESET_RECEIVER = "RESET_RECEIVER";
export const CHANGE_ORIGIN_FLOOR = "CHANGE_ORIGIN_FLOOR";
export const CHANGE_DEST_FLOOR = "CHANGE_DEST_FLOOR";
export const PROFILE_NAME_ERROR = "PROFILE_NAME_ERROR";
export const PROFILE_LAST_NAME_ERROR = "PROFILE_LAST_NAME_ERROR";
export const TOGGLE_ELEVATOR_ORIGIN = "TOGGLE_ELEVATOR_ORIGIN";
export const TOGGLE_ELEVATOR_DEST = "TOGGLE_ELEVATOR_DEST";
export const CHANGE_RECEIVER_DISPLAY = "CHANGE_RECEIVER_DISPLAY";
export const RETRIEVE_INVOICE_LIST = "RETRIEVE_INVOICE_LIST";
export const REMOVE_INVOICE_LIST = "REMOVE_INVOICE_LIST";
export const IS_SELECTING_LOCATION = "IS_SELECTING_LOCATION";
export const LOCATION_SELECTED = "LOCATION_SELECTED";
export const START_CHECKING_FOR_COMMENT = "START_CHECKING_FOR_COMMENT";
export const END_CHECKING_FOR_COMMENT = "END_CHECKING_FOR_COMMENT";
export const RATE = "RATE";
export const COMMENT = "COMMENT";
export const SEND_RATE_AND_COMMENT = "SEND_RATE_AND_COMMENT";
export const RETRIEVED_DRIVER_DATA = "RETRIEVED_DRIVER_DATA";
export const START_SENDING_COMMENT = "START_SENDING_COMMENT";
export const END_SENDING_COMMENT = "END_SENDING_COMMENT";
export const CHANGE_COMMENT = "CHANGE_COMMENT";
export const SENDING_ORDER = "SENDING_ORDER";
export const ORDER_SENT = "ORDER_SENT";
export const ASYNC_VERIFY_LOGIN = "ASYNC_VERIFY_LOGIN";
export const START_STORE_PROFILE = "START_STORE_PROFILE";
export const END_STORE_PROFILE = "END_STORE_PROFILE";
export const SHOW_DELETE_ALERT = "SHOW_DELETE_ALERT";
export const HIDE_DELETE_ALERT = "HIDE_DELETE_ALERT";
export const SET_ORDER_ID = "SET_ORDER_ID";
export const SET_SERVICE_STATUS = "SET_SERVICE_STATUS";
export const SET_MORE_SERVICES_ORDER = "SET_MORE_SERVICES_ORDER";
export const CHANGE_REFERRAL = "CHANGE_REFERRAL";
export const REFERRAL_OK = "REFERRAL_OK";
export const DISABLE_REFERRAL = "DISABLE_REFERRAL";
export const SET_EDITING_ORDER = "SET_EDITING_ORDER";
export const SET_SEARCH_PLACE_RESULT = "SET_SEARCH_PLACE_RESULT";
export const SEARCH_SELECTED = "SEARCH_SELECTED";
export const INCREASE_STOP_TIME = "PLUS_STOP_TIME";
export const DECREASE_STOP_TIME = "MINUS_STOP_TIME";
export const SET_ADDRESSES = "SET_ADDRESSES";
export const SET_DRIVER = "SET_DRIVER";
export const ASYNC_COUPON_START = "ASYNC_COUPON_START";
export const ASYNC_COUPON_END = "ASYNC_COUPON_END";
export const SET_TIMING = "SET_TIMING";
export const SET_PRICE_SUBMIT_BUTTON = "SET_PRICE_SUBMIT_BUTTON";
export const SET_PRICE_SUBMIT_BUTTON_ID = "SET_PRICE_SUBMIT_BUTTON_ID";
export const SET_HOURS = "SET_HOURS";
export const PREORDERING_PROGRESS_START = "PREORDERING_PROGRESS_START";
export const PREORDERING_PROGRESS_END = "PREORDERING_PROGRESS_END";
export const SUBMIT_ORDER_AFTER_ALL = "SUBMIT_ORDER_AFTER_ALL";
export const SUBMITTING_ORDER = "SUBMITTING_ORDER";
export const SET_MARKETING_TOKEN = "SET_MARKETING_TOKEN";
export const DISABLE_SHOULD_LOGIN = "DISABLE_SHOULD_LOGIN";
export const SET_INTERCITY = "SET_INTERCITY";
export const REFINE_BILL = "REFINE_BILL";
export const CHANGE_ORDER_DESCRIPTION = "CHANGE_ORDER_DESCRIPTION";
export const OPEN_DRAWER_MENU = "OPEN_DRAWER_MENU";
export const CLOSE_DRAWER_MENU = "CLOSE_DRAWER_MENU";
export const SHOW_BACK_BTN = "SHOW_BACK_BTN";
export const HIDE_BACK_BTN = "HIDE_BACK_BTN";
export const SET_CANCEL_REASON_TEXT = "SET_CANCEL_REASON_TEXT";
export const SET_CANCEL_TEXTAREA = "SET_CANCEL_TEXTAREA";
export const SET_SHOW_TIME_CARD = "SET_SHOW_TIME_CARD";
export const RETRIEVING_HEAVY_ITEMS = "RETRIEVING_HEAVY_ITEMS";
export const RETRIEVING_BUTTONS_PRICE_ITEMS = "RETRIEVING_HEAVY_ITEMS";
export const STORE_HEAVY_ITEMS = "STORE_HEAVY_ITEMS";
export const HIDE_HEADER = "HIDE_HEADER";
export const CHANGE_PROVIDER_NAME_IN_OFFER_FEEDBACK =
  "CHANGE_PROVIDER_NAME_IN_OFFER_FEEDBACK";
export const CHANGE_PRICE_OFFER_FEEDBACK = "CHANGE_PRICE_OFFER_FEEDBACK";
export const CHANGE_DESC_OFFER_FEEDBACK = "CHANGE_DESC_OFFER_FEEDBACK";
export const SHOW_PRICE_FEEDBACK_MODAL = "SHOW_PRICE_FEEDBACK_MODAL";
export const SENDING_PRICE_FEEDBACK = "SENDING_PRICE_FEEDBACK";
export const CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS =
  "CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS";
export const CHANGE_AREA_VALUE = "CHANGE_AREA_VALUE";
export const UPDATE_DRIVER_LOCATION = "UPDATE_DRIVER_LOCATION";
export const CHANGE_UTM_SOURCE = "CHANGE_UTM_SOURCE";
export const RATING = "RATING";
export const CHANGE_RATE = "CHANGE_RATE";
export const CHANGE_CALL_CENTER_PHONE_NUMBER =
  "CHANGE_CALL_CENTER_PHONE_NUMBER";
export const INCREASE_WALKING = "INCREASE_WALKING";
export const DECREASE_WALKING = "DECREASE_WALKING";
export const SET_WORKER_VALUE = "SET_WORKER_VALUE";
